const normalizeUrl = (value: string) => value.replace(/\/+$/, "");

// URLs are injected at build time by webpack's DefinePlugin. The webpack
// config picks a mode-aware fallback (local in dev, production URL in prod)
// when no env var is set, so this file just trusts whatever was injected.
const fallbackApiUrl = "https://nberpapi.lbpos.com";

const supplierApiUrl = process.env.SUPPLIER_API_URL || fallbackApiUrl;
const adminApiUrl = process.env.ADMIN_API_URL || fallbackApiUrl;

export const runtimeConfig = {
  supplierApiUrl: normalizeUrl(supplierApiUrl),
  adminApiUrl: normalizeUrl(adminApiUrl),
} as const;
